module.exports = __webpack_public_path__ + "static/media/log_11.74f56ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_11.jpg
// module id = 1900
// module chunks = 0